module.exports = __webpack_public_path__ + "img/flow@2x.b4c17d51.png";